var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-loader',{attrs:{"loading":_vm.loadingData}},[_c('configs-component',{attrs:{"configs":_vm.userConfig,"loading":_vm.loading},on:{"confirm":_vm.updateUserConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }